import { request } from 'Apiv2/handleRequest';

export const getAppointmentsApiWrapper = (requestProvider = request) => {
  return async (carePlanId) => {
    try {
      const response = await requestProvider(
        `/care_plans/${carePlanId}/care_plan_action_plan_view_page/appointments`,
        'GET'
      );

      const status = response.status;
      const { appointments, repeated_appointments } = await response.json();

      if (status === 200) {
        return {
          responseType: 'DATA',
          appointments,
          repeatedAppointments: repeated_appointments,
        };
      } else {
        throw 'Missing data';
      }
    } catch (error) {
      console.error(error);
      return { responseType: 'API_ERROR' };
    }
  };
};

export default getAppointmentsApiWrapper(request);
